import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsEnum, IsNumber } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import {
  EDevicePoolSourceKind,
  EDevicePoolMemberOverride,
} from './security.enums';

@Index(['poolId', 'userId'], { unique: true })
@Index(['userId'], { unique: true })
export class DevicePoolMember extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: false })
  poolId: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsEnum(EDevicePoolSourceKind, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EDevicePoolSourceKind, nullable: false })
  joinedVia: EDevicePoolSourceKind;

  @ApiProperty()
  @IsEnum(EDevicePoolMemberOverride, { groups: ['error'] })
  @Column({
    type: 'varchar',
    enum: EDevicePoolMemberOverride,
    nullable: false,
    default: EDevicePoolMemberOverride.auto,
  })
  override: EDevicePoolMemberOverride;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  linkStrengthMilli: number;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  joinedAt: Date;
}
